export function getChannelCoverUrl(channelData) {
  const { coverUrl, customCoverUrl } = channelData;
  return customCoverUrl || coverUrl;
}



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/channel/cover.js